/**
 * Yasal metinlerin sürümü ve adresleri.
 *
 * Metinler tanıtım sitesinde (site/kvkk.html, kullanici-sozlesmesi.html,
 * gizlilik.html). Birinde anlamı değişen bir düzeltme yapılınca sürüm
 * artırılıyor: patronlar bir sonraki girişlerinde yeni sürümü onaylıyor
 * (components/LegalGate). Onaylar supabase/yasal-onay.sql'deki tabloda.
 */
export const LEGAL_VERSION = '1.0'

/**
 * Şirket kurulana kadar kapalı (kullanıcı, 2 Eki 2026): metinlerde unvan,
 * adres, vergi no yok. Kapalıyken kayıtta onay kutusu yok, girişte onay
 * penceresi yok, kayıt isteği onay sürümü göndermiyor. Şirket bilgileri
 * site/*.html'e yazılınca true yapılır.
 */
export const LEGAL_ENABLED = false

// Geliştirmede sitenin yerel kopyası (cd site && python3 -m http.server 5190);
// orada adresler .html uzantılı.
const SITE = import.meta.env.DEV ? 'http://localhost:5190' : 'https://www.adissoo.com'
const EXT = import.meta.env.DEV ? '.html' : ''
export const LEGAL_URLS = {
  terms: `${SITE}/kullanici-sozlesmesi${EXT}`,
  privacy: `${SITE}/gizlilik${EXT}`,
  kvkk: `${SITE}/kvkk${EXT}`,
}
